import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import type { ThemeMode } from '../../../src/theme/ThemeContext';
import type { getCardDimensions } from './FriendCardBase.styles';

export const getFriendCardStatsStyles = (theme: Theme, themeMode?: ThemeMode) =>
  StyleSheet.create({
    friendName: {
      fontSize: 17,
      fontWeight: '700',
      color: theme.black,
      marginBottom: 8,
      textAlign: 'center',
      paddingHorizontal: 4,
    },
    /** Group cover card: single-line title with ellipsis needs horizontal bounds in a centered column. */
    groupImageCardTitle: {
      alignSelf: 'stretch',
      marginTop: 8,
    },
    friendNameTop: {
      marginBottom: 4,
      marginTop: 0,
      color: themeMode === 'light' ? theme.black : theme.black,
      textShadowColor: themeMode === 'light' ? 'transparent' : 'rgba(0, 0, 0, 0.35)',
      textShadowOffset: { width: 0, height: 1 },
      textShadowRadius: themeMode === 'light' ? 0 : 4,
    },
    statText: {
      fontSize: 12,
      color: theme.gray[600],
      fontWeight: '500',
      textAlign: 'center',
    },
    secondarySubtitleWrap: {
      marginTop: 2,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    },
    statBadge: {
      backgroundColor: theme.gray[100],
      paddingHorizontal: 10,
      paddingVertical: 6,
      borderRadius: 8,
      alignItems: 'center',
      minWidth: 70,
    },
    statBadgeValue: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.primary,
      marginBottom: 2,
    },
    statBadgeLabel: {
      fontSize: 11,
      color: theme.gray[600],
      fontWeight: '500',
    },
  });

/** Win/loss coin delta row under avatar (friends tab). */
export const getWinRateCoinSubtitleStyles = (
  theme: Theme,
  dimensions: ReturnType<typeof getCardDimensions>
) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 3,
      justifyContent: 'center',
    },
    value: {
      fontSize: dimensions.fontSizeStat,
      fontWeight: '600',
    },
    valuePositive: {
      color: theme.success,
    },
    valueNegative: {
      color: theme.error,
    },
    valueNeutral: {
      color: theme.gray[500],
    },
    image: {
      width: Math.round(dimensions.fontSizeStat + 4),
      height: Math.round(dimensions.fontSizeStat + 4),
    },
  })

/** Balance row under avatar (create challenge picker). */
export const getCoinBalanceRowStyles = (
  theme: Theme,
  themeMode: ThemeMode | undefined,
  dimensions: ReturnType<typeof getCardDimensions>
) =>
  StyleSheet.create({
    // Design footer: coin value (+ our coin icon) on the left, chevron on the right.
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginTop: 6,
      marginBottom: 4,
      zIndex: 2,
    },
    coinGroup: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 3,
    },
    value: {
      fontSize: dimensions.fontSizeStat,
      fontWeight: '700',
      color: themeMode === 'dark' ? theme.gray[900] : theme.gray[800],
    },
    icon: {
      width: Math.round(dimensions.fontSizeStat + 4),
      height: Math.round(dimensions.fontSizeStat + 4),
    },
  })

export const getFriendNameStyle = (dimensions: ReturnType<typeof getCardDimensions>) => ({
  fontSize: dimensions.fontSizeName,
  marginBottom: dimensions.nameMarginBottom,
});

export const getStatTextStyle = (dimensions: ReturnType<typeof getCardDimensions>) => ({
  fontSize: dimensions.fontSizeStat,
});
